import { Home } from "./components/home/Home";
import { Test } from "./components/Test";
import { Beneficios } from "./components/beneficios/Beneficios";
import { Administrador } from "./components/administrador/Administrador";
import { Test2 } from "./components/administrador/Test2";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/beneficios',
    element: <Beneficios />
  },
  {
    path: '/test',
    element: <Test />
  },
  {
      path: '/admin',
      element: <Administrador />
  }
];

export default AppRoutes;
